module.exports = __webpack_public_path__ + "sns.svg?81cdc903219a0971201a34d46de9372e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sns.svg
// module id = 250
// module chunks = 0